<template>
    <div class="scheme">
        <div class="mbx clearfix">
            <el-breadcrumb class="fl" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item>活动印花</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="primary" class="fr" @click="addActivity">添加</el-button>
        </div>
        <!-- 表格 -->
        <el-table :data="tableData.list" border style="width: 100%">
            <el-table-column prop="title" label="标题" width="380">
            </el-table-column>
            <el-table-column prop="companyNewsImg" label="图片">
                <template slot-scope="scope">
                    <img :src="url+scope.row.companyNewsImg" width="300" height="100" class="head_pic" />
                </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button @click="amendClick(scope.row)" type="text" size="small">修改</el-button>
                    <el-button @click="removeClick(scope.row)" type="text" size="small">整体删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="block">
            <el-pagination v-model="tableData" @current-change="handleCurrentChange" :current-page.sync="tableData.pageNum" layout="total, prev, pager, next, jumper" :total="tableData.total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import { activityGetPageList, updateActivityImgs } from '../api/api.js'
    export default {
        name: 'scheme',
        created() {
            activityGetPageList().then((res) => {
                this.tableData = res.data.data;
                for (let i = 0; i < this.tableData.list.length; i++) {
                    if (this.tableData.list[i].companyNewsImg != null) {
                        this.tableData.list[i].companyNewsImg = this.tableData.list[i].companyNewsImg.split(',')[0]
                    }
                }
            })
        },
        data() {
            return {
                url: this.GLOBAL.picURL,
                tableData: [],
                shemeForm: {
                    title: '',
                    description: '',
                    companyNewsImg: ''
                },
                shemeAmendForm: {},
                formLabelWidth: '100px',
                rules: {
                    title: [
                        { required: true, message: '请输入标题', trigger: 'blur' }
                    ],
                    description: [
                        { required: true, message: '请输入文案', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            // 修改点击
            amendClick(param) {
                this.$router.push({ path: '/ht_updateActivity', query: { id: param.activityImgId } });
            },
            removeClick(param) {
                updateActivityImgs({
                    activityImgId: param.activityImgId,
                    activityImgStatus: 3,
                }).then(res => {
                    if (res.status === 1) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        activityGetPageList().then((res) => {
                            this.tableData = res.data.data;
                            for (let i = 0; i < this.tableData.list.length; i++) {
                                if (this.tableData.list[i].companyNewsImg != null) {
                                    this.tableData.list[i].companyNewsImg = this.tableData.list[i].companyNewsImg.split(',')[0]
                                }
                            }
                        })
                    }
                })
            },
            // 添加点击
            addActivity() {
                this.$router.push({ path: '/ht_addactivity' });
            },
            // 分页
            handleCurrentChange(val) {
                companyNews({ pageNum: val }).then((res) => {
                    this.tableData = res.data.data;
                })
            },
        }
    }
</script>

<style scoped>
    .mbx {
        background-color: #f5f5f5;
        padding: 1% 4%;
    }

    .block {
        float: right
    }
</style>



// WEBPACK FOOTER //
// src/components/ht_activity.vue